
import React, {Component} from "react";
import {bindActionCreators} from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Store from "store";
import {fetchEvents} from "store/posts/actions";
// import TagManager from 'react-gtm-module'
import Events from '/components/Brand/Events';
import NProgress from "components/NProgress";

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

  class EventSummary extends Component {
    constructor(props){
        super(props);
    }

    static async getInitialProps({store, query, asPath, isServer, res}) {
        await store.execSagaTasks(isServer, dispatch => {
            dispatch(fetchEvents());
          });
        return {asPath, isServer};   
    }


    render() {
        const { events } = this.props;
        return (
            <>
                <NProgress />
                <Events items={events} thereIsNo="There are no events." />
            </>

        );
    }
    componentDidMount() {
        const {isServer} = this.props;
        window.noGlobalAds = true;
    }
      
    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)
    }
}



const mapStateToProps = state => ({
    events: state.posts.events.data,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchEvents,
}, dispatch);

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(withReduxSaga(EventSummary));
